export enum ModificationType {
    delete = 'delete',
    insert = 'insert',
    update = 'update',
}
